// import React from "react";
// import CountUp from "./CountUp";
// import "../assets/css/attendanceCard.css";

// /**
//  * Pastel attendance stat card.
//  *
//  * `direction` comes straight from the API ("up" | "down" | "same") and drives
//  * both the caption text and its colour, so "same" reads as a neutral
//  * "No change" instead of a green "+0".
//  */
// const AttendanceCard = ({
//   title,
//   count = 0,
//   unit = "nos",
//   delta = 0,
//   direction = "same",
//   deltaLabel = "vs previous",
//   bg = "#f1f5f9",
//   badge = "#64748b",
//   icon,
//   footerItems = [],
// }) => {
//   const trend =
//     direction === "up" ? "up" : direction === "down" ? "down" : "same";

//   const captionText =
//     trend === "same"
//       ? `No change ${deltaLabel}`
//       : `${trend === "up" ? "+" : "-"}${Math.abs(delta)} ${deltaLabel}`;

//   return (
//     <div
//       className="pastel-card"
//       style={{ "--pastel-bg": bg, "--pastel-badge": badge }}
//     >
//       <div className="pastel-card-badge">{icon}</div>

//       <div className="pastel-card-value">
//         <CountUp
//           className="pastel-card-count"
//           value={count}
//           format={(n) => n.toLocaleString()}
//         />
//         <span className="pastel-card-unit">{unit}</span>
//       </div>

//       <div className="pastel-card-title">{title}</div>

//       <div className={`pastel-card-caption caption-${trend}`}>
//         {captionText}
//       </div>

//       {footerItems.length > 0 && (
//         <div className="pastel-card-footer">
//           {footerItems.map((item, index) => (
//             <span key={index} className="pastel-footer-item">
//               {item.label} <strong>{item.value}</strong>
//             </span>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default AttendanceCard;


import React from "react";
import CountUp from "./CountUp";
import "../assets/css/attendanceCard.css";

/**
 * Pastel attendance stat card.
 *
 * `direction` comes straight from the API ("up" | "down" | "same") and drives
 * both the caption text and its colour, so "same" reads as a neutral
 * "No change" instead of a green "+0".
 */
const AttendanceCard = ({
  title,
  count = 0,
  unit = "nos",
  delta = 0,
  direction = "same",
  deltaLabel = "vs previous",
  // bg = "#f1f5f9",
  // badge = "#64748b",
  bg = "#f1f5f9",
  border = "#dbeafe",
  badge = "#64748b",
  iconBg = "#ffffff",
  icon,
  footerItems = [],
}) => {
  const trend =
    direction === "up" ? "up" : direction === "down" ? "down" : "same";

  const captionText =
    trend === "same"
      ? `No change ${deltaLabel}`
      : `${trend === "up" ? "+" : "-"}${Math.abs(delta)} ${deltaLabel}`;

  return (
    // <div
    //   className="pastel-card"
    //   style={{ "--pastel-bg": bg, "--pastel-badge": badge }}
    // >
    //   <div className="pastel-card-badge">{icon}</div>

    //   <div className="pastel-card-value">
    //     <CountUp
    //       className="pastel-card-count"
    //       value={count}
    //       format={(n) => n.toLocaleString()}
    //     />
    //     <span className="pastel-card-unit">{unit}</span>
    //   </div>

    //   <div className="pastel-card-title">{title}</div>

    //   <div className={`pastel-card-caption caption-${trend}`}>
    //     {captionText}
    //   </div>

    //   {footerItems.length > 0 && (
    //     <div className="pastel-card-footer">
    //       {footerItems.map((item, index) => (
    //         <span key={index} className="pastel-footer-item">
    //           {item.label} <strong>{item.value}</strong>
    //         </span>
    //       ))}
    //     </div>
    //   )}
    // </div>
    <div
      className="pastel-card"
      style={{
        "--pastel-bg": bg,
        "--pastel-border": border,
        "--pastel-badge": badge,
        "--pastel-icon-bg": iconBg,
      }}
    >
      <div className="pastel-card-top">
        <div className="pastel-card-badge">
          {icon}
        </div>
        <div className="pastel-card-content">
          <div className="pastel-card-header">

            <div>
              <div className="pastel-card-value">
                <CountUp
                  className="pastel-card-count"
                  value={count}
                  format={(n) => n.toLocaleString()}
                />
              </div>
              <div className="pastel-card-title">
                {title}
              </div>
              <div className="pastel-card-trend">
                <div className={`pastel-card-caption caption-${trend}`}>
                  {captionText}
                </div>          
              </div>
            </div>
            <div className="trend-icon">
              {
                trend === "up"
                  ? <i className="bi bi-graph-up-arrow"></i>
                  : trend === "down"
                    ? <i className="bi bi-graph-down-arrow"></i>
                    : <i className="bi bi-dash-lg"></i>
              }
            </div>
          </div>
        </div>
      </div>
      {
        footerItems.length > 0 && (
          <div className="pastel-card-footer">
            {footerItems.map((item, index) => (
              <span
                key={index}
                className="pastel-footer-item"
              >
                {item.label}
                <strong>{item.value}</strong>
              </span>
            ))}
          </div>
        )
      }
    </div>
  );
};

export default AttendanceCard;
